export type SyncResource = 'token' | 'quota' | 'history';

export interface SyncFailureContext {
  resource: SyncResource;
  requestId?: string;
  tokenType?: 'device' | 'user';
  retryCount?: number;
  metadata?: Record<string, unknown>;
}

export interface SyncFailurePayload {
  context: SyncFailureContext;
  error: unknown;
  occurredAt: string;
}

export type SyncReporter = (payload: SyncFailurePayload) => void;

const consoleReporter: SyncReporter = (payload) => {
  console.warn('[SyncFailure]', payload.context.resource, payload);
};

let reporter: SyncReporter = consoleReporter;

export function registerSyncReporter(customReporter: SyncReporter) {
  reporter = customReporter;
}

export function logSyncFailure(context: SyncFailureContext, error: unknown) {
  const payload: SyncFailurePayload = {
    context,
    error,
    occurredAt: new Date().toISOString()
  };

  try {
    reporter(payload);
  } catch (reportError) {
    console.error('Failed to report sync failure', reportError, payload);
  }
}
